import React from 'react';

interface WeatherIconProps {
    className?: string;
    style?: React.CSSProperties;
}

const WeatherIcon: React.FC<WeatherIconProps> = ({ className, style }) => {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={style}
        >
            {/* 云朵主体 */}
            <path
                d="M18.5 14.5C19.3284 14.5 20 13.8284 20 13C20 12.1716 19.3284 11.5 18.5 11.5C18.2 11.5 17.9 11.6 17.7 11.7C17.3 9.3 15.2 7.5 12.8 7.5C10.4 7.5 8.3 9.3 7.9 11.7C7.7 11.6 7.4 11.5 7.1 11.5C5.9 11.5 5 12.4 5 13.5C5 14.6 5.9 15.5 7.1 15.5H18.5Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            {/* 雨点1 */}
            <path
                d="M9 18L9 20"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            {/* 雨点2 */}
            <path
                d="M12 17L12 19"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            {/* 雨点3 */}
            <path
                d="M15 18L15 20"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default WeatherIcon;

